/* @flow */
import type { ReduxState, Action, Fetchable, FindSmartlistParams, Smartlist } from 'types';
// ===========================
//   STATE TYPE
// ===========================
export type SmartlistsState = {
  params: FindSmartlistParams,
  smartlists: Fetchable<Smartlist[]>,
  pageScroll: number,
};

const initialPageScroll = 0;

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: SmartlistsState = {
  params: {},
  smartlists: { fetching: false },
  pageScroll: initialPageScroll,
};

const isStaleRequest = (params?: FindSmartlistParams, requestParams: FindSmartlistParams) => {
  return false;
};

// ===========================
//   REDUCER
// ===========================
export default (state: SmartlistsState = initialState, action: Action): SmartlistsState => {
  switch (action.type) {
    case 'FETCH_SMARTLISTS_REQUEST': {
      return {
        ...state,
        smartlists: { fetching: true },
      };
    }
    case 'FETCH_SMARTLISTS_SUCCESS': {
      if (!isStaleRequest(state.params, action.meta.initialPayload)) {
        const data = action.payload;
        return {
          ...state,
          smartlists: { data, fetching: false },
          pageScroll: initialPageScroll,
        };
      } else {
        // ignore results
        return state;
      }
    }
    case 'FETCH_SMARTLISTS_FAILURE': {
      if (!isStaleRequest(state.params, action.meta.initialPayload)) {
        const error = action.payload;
        return {
          ...state,
          smartlists: { error, fetching: false },
          pageScroll: initialPageScroll,
        };
      } else {
        // ignore results
        return state;
      }
    }
    case 'SMARTLISTS_SCROLL_PAGE': {
      const pageScroll = action.payload || 0;
      return {
        ...state,
        pageScroll,
      };
    }
    case 'LOGOUT_SUCCESS':
      return initialState;

    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getFindSmartlistParams = (state: ReduxState): FindSmartlistParams => {
  return state.smartlists.params;
};

export const getSmartlists = (state: ReduxState): Fetchable<Smartlist[]> => {
  return state.smartlists.smartlists;
};
